// JavaScript source code
import React, { useEffect, useState } from 'react';
import { useParams, Link,useNavigate } from 'react-router-dom';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import Button from '../components/button';
import LoginDialog from '../components/loginDialog';
import { getUser } from '../request';
import config from '../config';
import dataJoinUs from '../assets/fake-data/data-joinus';

function JoinUsStep(props) {    
    let activeIndex = 3;
    const theData = dataJoinUs;

    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    useEffect(() => {
        
    }, [isShowLogin, user]);
    const navigate = useNavigate();
    
    const handleLoginClick = () => {
        setIsShowLogin(true);
    }
    const finishLogin = () => { 
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    return (      
        <div className={`aboutUs joinUs`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content js_content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent">
                    <div className="title">入驻流程</div>
                    <div className="step_flow"></div>
                    <div className="step_content">
                        <div className="step_title">
                            感谢您选择和认可德联的入驻合作模式，请仔细阅读如下须知，将会对您使用德联官网在线入驻流程带来帮助。
                        </div>
                        <div className="step_detail">
                            <p>
                                ① 在提交申请前，您首先需要
                                <Link className="blue" to={`${config.root}/JoinUsStep1`}>
                                    注册</Link>
                                成为本网站“服务商用户”；如已有账号，请先
                                <Link className="blue" onClick={() =>handleLoginClick()}>登录</Link>
                            </p><p>② 在注册成功后，系统自动完成登录。
                            </p><p>③ 点击本网页底部“下一步”按钮，按步骤填写和上传资料。
                            </p><p>④ 只有在您完成第四步“确认提交”后，您所填写和上传的资料系统将保存下来。
                            </p><p>⑤ 提交申请后，请等待德联车护对您提交的资料进行审核（一般为1-2个工作日）。
                            </p>
                        </div>
                        <div className="step_detail">
                            德联车护的工作人员将会及时与您联系。双方正式签署入驻合同后，您将可以通过“我的德联”进行日常业务操作。
                            <br/>届时如您的信息资料有变更，请联系德联客服（客服电话：
                            <span className="blue">   400-9202-505</span>
                            ）为您修改。
                        </div>
                        {
                            !(user && user.business) &&
                            <Button btnclass="regist_btn " path='/JoinUsStep1' title="去注册" />
                        }
                        {
                            user && user.business &&
                            <Button btnclass="regist_btn " path='/JoinUsStep2' title="下一步" />
                        }
                    </div>

                </div>

            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>
          
    );
}

export default JoinUsStep;